import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RecepcionDTO } from "app/main/apps/shared/interfaces/recepcion.interface";

@Component({
    selector: "app-recepcion-oocc",
    templateUrl: "./recepcion-oocc.component.html",
    styleUrls: ["./recepcion-oocc.component.scss"],
})
export class RecepcionOoccComponent implements OnInit {
    @Input() recepcion: RecepcionDTO;
    @Input() idOOCC: number;

    @Output() asociarRocGesEvent: EventEmitter<{
        numeroGes: string;
        nuevo: boolean;
    }> = new EventEmitter();
    @Output() asociarInformeEvent: EventEmitter<void> = new EventEmitter();
    @Output() modificarRocGesEvent: EventEmitter<{
        numeroGes: string;
        nuevo: boolean;
    }> = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    asociarRocGes() {
        const data = {
            numeroGes: null,
            nuevo: true,
        };
        //console.log(data);
        this.asociarRocGesEvent.emit(data);
    }
    asociarInforme() {
        this.asociarInformeEvent.emit();
    }
    modificarRocGes(numeroGes: string) {
        const data = {
            numeroGes,
            nuevo: false,
        };
        this.modificarRocGesEvent.emit(data);
    }
}
